// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox';
import 'mixitup/dist/mixitup.min';
// import 'fancybox/dist/js/jquery.fancybox';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import { faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faChevronDown, faChevronLeft, faChevronRight, faFilePdf, faShareAlt, faPoundSign, faCaretLeft, faCaretRight, faArrowRight, faLongArrowRight, faTimes, faShare, faCheck, faGem, faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin } from '@fortawesome/free-brands-svg-icons';
config.searchPseudoElements=true;
library.add(faPhone, faPhoneSquare, faPrint, faEnvelope, faEnvelopeOpen, faMapMarkerAlt, faBars, faFacebook, faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faLinkedin, faChevronDown, faChevronLeft, faChevronRight, faFilePdf, faShareAlt, faPoundSign, faCaretLeft, faCaretRight, faArrowRight, faLongArrowRight, faTimes, faShare, faCheck, faGem, faShieldCheck);
dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js